module.exports = MaterialUI.Slider;